<template>
  <div class="notification-grid">
    <profile-avatar
      :presetProfilePic="notification.notificationData.friend.profilePicture"
      :username="notification.notificationData.friend.username"
      :size="$vuetify.breakpoint.xs ? 32 : 48"
    ></profile-avatar>
    <div class="notification-message">
      <router-link :to="profileRoute">{{ notification.notificationData.friend.username }}</router-link>
      <br />
      accepted your friend request
      <br />
      <span class="notification-timestamp">
        {{ relativeDateString(new Date(notification.timeCreated).getTime()) }}
      </span>
    </div>
    <v-btn class="notification-action" color="primary" elevation="0" small :to="profileRoute">view profile</v-btn>
  </div>
</template>

<script>
/**
 * @typedef {Object} NewFriendRequestNotificationProp
 * @property {string} id - The notification id
 * @property {Object} notificationData
 * @property {string} notificationData.requestStatus
 * @property {Object} notificationData.friend
 */

import profileAvatar from "../profile-avatar.vue";
import { relativeDateString } from "../../util/dateHelpers";

export default {
  name: "accepted-friend-request-notification",

  props: {
    /**
     * @type {NewFriendRequestNotificationProp}
     */
    notification: Object,
  },

  components: { profileAvatar },

  computed: {
    profileRoute() {
      return { name: "profile", params: { username: this.notification.notificationData.friend.username } };
    },
  },

  methods: {
    relativeDateString,
  },
};
</script>
